import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import { Collage, FAQ2 } from "../components/Sections";

export default function Software() {
  useEffect(() => {}, []);
  const dark = true;

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "35px" : "8.75vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                <h1>
                  Designing with Purpose, <br />
                  <span style={{ color: "yellow" }}>
                    Delivering with Precision.
                  </span>
                </h1>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Enhancing user experiences through intuitive, beautiful
                interfaces
              </div>
            </div>
          </div>
        </div>

        <ContentSideBySideInv
          title={<h2>Key Benefits of Our UI/UX Design Solutions</h2>}
          subtitle={
            <div>
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                User Research and Experience Mapping
              </div>
              We analyze user behavior and define interaction goals. Our team
              structures intuitive layouts that improve accessibility. We also
              optimize design elements to create a seamless experience.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Custom UI Design and Interactive Prototyping
              </div>
              We develop visually appealing interfaces that improve usability.
              Our team builds interactive prototypes and tests functionality. We
              also refine visual elements to improve responsiveness and
              navigation.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Conversion-Focused UX Optimization
              </div>
              We design structured user flows that improve engagement. Our team
              simplifies interactions and enhances accessibility. We also
              optimize call-to-action elements to drive better results.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/uiux.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 300 : 400}
              width={state.auth.isMobile ? 300 : 400}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        {!state.auth.isMobile ? (
          <SpacerV height={"100px"} background="white" />
        ) : (
          ""
        )}

        <SpacerV height={"6vh"} background="white" />

        <ThreeSideBySide
          background={""}
          spacing={5}
          subtitle1={
            <FeatureCard
              minHeight={"45vh"}
              title={"Mobile-Optimized Interface"}
              text={`We design responsive UI elements that function seamlessly on any device. We work on implementing a structured layout as it improves usability and enhances user experience.`}
              icon={
                <TravelExploreIcon
                  style={{
                    fontSize: state.auth.isMobile ? "25px" : "6vh",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
          subtitle2={
            <FeatureCard
              minHeight={"45vh"}
              title={"Consistent Design Language"}
              text={`Our team ensures uniformity across all digital platforms. We also create structured design systems that improve brand recognition and user retention.`}
              icon={
                <DvrIcon
                  style={{
                    fontSize: state.auth.isMobile ? "25px" : "6vh",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
          subtitle3={
            <FeatureCard
              minHeight={"45vh"}
              title={"Performance-Driven UI Elements"}
              text={`We develop optimized design components that improve functionality. Our structured approach makes sure that users get better accessibility and faster interactions.`}
              icon={
                <WindowIcon
                  style={{
                    fontSize: state.auth.isMobile ? "25px" : "6vh",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
        />

        <FAQ2
          invert={!dark}
          q1="What makes UI/UX design successful?"
          a1="A successful UI/UX design creates a seamless experience that levels up usability and encourages interaction. Here are the promising elements that raise the success bar for a UI and UX design: A structured interface ensures easy navigation, while intuitive layouts improve accessibility. Thoughtful design elements guide users through a smooth journey. They also reduce friction and increase conversions. A well-optimized UI/UX enhances engagement and supports business objectives by improving user satisfaction and retention."
          q2="How long does it take to complete a UI/UX design project?"
          a2="Timelines mainly rely on complexity and required features. A basic UI/UX design is completed within six to eight weeks. Custom interfaces and advanced optimizations take longer."
          q3="What tools do you use for UI/UX design?"
          a3="We utilize and employ industry-leading tools such as Figma and Adobe XD. Our team creates structured prototypes that improve user testing and refinement."
          q4="Can I update the UI/UX design after deployment?"
          a4="Yes, UI/UX designs can be updated based on user feedback. A structured design system allows seamless modifications and enhancements."
          q5="How does UI/UX design impact business success?"
          a5="A well-structured design improves user retention and conversion rates. A clear interface and smooth interaction flow also help increase engagement."
          q6="How can I improve UI/UX for better user engagement?"
          a6="A simplified navigation structure improves usability. Work on optimized interactive elements as they level up user experience. Next, focus and work on the execution of responsive design as it increases accessibility across devices."
        />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}></div>
        <Stats />
        <SpacerV height={"100px"} background="#111" />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
